import {
  GET_ACTIVE_PAGE,
  SET_CUSTOMERID,
  SET_SHOPDOMAIN,
  SET_PARENTLOCATION,
  SET_ISDISCOUNTCARD,
} from "../actions/constants/constants";

const APP_STATE = {
  activePage: "home",
  shopDomain: "",
  customerId: "",
  parentLocation: "",
  isDiscountCard: false,
};

const AppstateReducer = (state = APP_STATE, action) => {
  switch (action.type) {
    case GET_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    case SET_CUSTOMERID:
      return { ...state, customerId: action.payload };
    case SET_SHOPDOMAIN:
      return { ...state, shopDomain: action.payload };
    case SET_PARENTLOCATION:
      return { ...state, parentLocation: action.payload };
    case SET_ISDISCOUNTCARD:
      return { ...state, isDiscountCard: action.payload };

    default:
      return {
        ...state,
      };
  }
};

export default AppstateReducer;
